import { render } from "./NoteAndComment.vue?vue&type=template&id=1e5251ee"
import script from "./NoteAndComment.vue?vue&type=script&lang=js"
export * from "./NoteAndComment.vue?vue&type=script&lang=js"

import "./NoteAndComment.vue?vue&type=style&index=0&id=1e5251ee&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__